export function createQueryParams(record: Record<string, any>): string {
    let params: string[] = [];

    for (const key in record) {
        const value = record[key];
        if (!value) {
            continue;
        }

        if (Array.isArray(value)) {
            if (value.length === 0) {
                continue;
            }

            const valueParams = value.map((v) => `${key}=${v}`);
            params = params.concat(valueParams);

            continue;
        }

        const valueParam = `${key}=${value}`;
        params.push(valueParam);
    }

    if (params.length === 0) {
        return "";
    }

    return `?${params.join("&")}`;
}

export function excludeQueryParam(urlString: string, paramToExclude: string): string {
    const url = new URL(urlString);
    url.searchParams.delete(paramToExclude);

    const resultUrlString = url.toString();

    return resultUrlString;
}

export function UrlSearchParams_append(searchParams: URLSearchParams, paramName: string, paramValue: any): void {
    if (!searchParams || !paramName || paramValue === undefined || paramValue === null || paramValue === "") {
        return;
    }

    if (Array.isArray(paramValue)) {
        paramValue.forEach((v) => searchParams.append(paramName, v.toString()));
    } else {
        searchParams.append(paramName, paramValue.toString());
    }
}
